// From http://www.redblobgames.com/
// Copyright 2015 Red Blob Games <redblobgames@gmail.com>
// License: Apache v2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>

/* Render a 2D array (from map2d.js) to a canvas
 *
 * Render the map to an off-screen buffer, then scale it up or down
 * when rendering to the screen.
 */

import { draw } from "./render-common.js";


export default class Renderer {
    constructor(elementId, map, colorMap) {
        this.draw = draw;
        this.elementId = elementId;
        this.map = map;
        this.colorMap = colorMap;
    }
    
    setup() {
        this.buffer = document.createElement('canvas');
        this.buffer.width = this.map.w;
        this.buffer.height = this.map.h;
    }
    
    getContext() {
        return this.canvas.getContext('2d');
    }
    
    _draw() {
        this._drawToBuffer();

        this.canvas.width = this.buffer.width;
        this.canvas.height = this.buffer.height;
        let ctx = this.getContext();
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        ctx.save();
        ctx.scale(this.canvas.width / this.buffer.width,
                  this.canvas.height / this.buffer.height);
        ctx.drawImage(this.buffer, 0, 0);
        ctx.restore();
    }
    
    _drawToBuffer() {
        const {map, colorMap} = this;
        const {w, h} = map;
        let ctx = this.buffer.getContext('2d', {willReadFrequently: true});
        let imageData = ctx.getImageData(0, 0, w, h);
        let pixels = imageData.data;

        for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
                let p = 4 * (y * w + x);
                let c = colorMap(x, y, map.get(x, y));
                for (let i = 0; i < 3; i++) {
                    pixels[p + i] = c[i];
                }
                pixels[p + 3] = 255;
            }
        }
        ctx.putImageData(imageData, 0, 0);
    }
}
